import React from "react"

interface Props {
    bodyMsg: string;
    title: string;
    isEng: boolean;
    Visible: boolean;
}

export class WarningAlertComponent extends React.Component<Props> {
    dateTypeFieldList = [];

    constructor(props: Props) {
        super(props);
    }

    generateHtmlString = () => {
        if (!this.props.Visible) {
            return null;
        }
        
        let html = [];
        let title = this.props.title;
        const HtmlToReactParser = require('html-to-react').Parser;
        const htmlToReactParser = new HtmlToReactParser(); 
        let bodyMsg = this.props.bodyMsg;
        if (/<[a-z][\s\S]*>/i.test(this.props.bodyMsg)) {
             bodyMsg=htmlToReactParser.parse(this.props.bodyMsg);
        }
        html.push(
            <div className="ontario-alert ontario-alert--warning callout-max-width">
                <div className="ontario-alert__header">
                    <div className="ontario-alert__header-icon">
                        <svg className="ontario-icon"  aria-hidden="true" focusable="false"  viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                            <use href="#ontario-icon-alert-warning"></use>
                        </svg>
                    </div>
                    <h2 className="ontario-alert__header-title ontario-h4">{title}</h2>
                </div>
                <div className="ontario-alert__body">
                    <p>{bodyMsg}</p>
                </div>
            </div>
        );
        return html;
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
